// Lib
import React from 'react';
import classNames from 'classnames';

// Components
import Tool, { ToolProps } from './Tool';

// Styles
import './ToolbarTool.scss';

interface ToolbarToolProps extends ToolProps {
    children: React.ReactNode;
    name?: string;
    className?: string;
    isOpen?: boolean;
    onClick?: () => void;
    preventFocusChange?: boolean;
}

const ToolbarTool = (props: ToolbarToolProps) => (
    <Tool {...props} className={classNames('ToolbarTool', props.className, { open: props.isOpen })} />
);

export default ToolbarTool;
